module.exports = __webpack_public_path__ + "img/wh44.985c413b.png";